<template>
  <table width="100%" style="table-layout: fixed" @click="jieti">
    <tr v-for="(row,ii) in data">
      <td style="border: 1px solid #cccccc;  text-align: center;height: 50px" v-for="(col,jj) in row"
          :class="{color_red:i===ii&&j===jj}">
        {{ col|showVal }}
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "sd",
  filters: {
    showVal(val) {
      if (typeof val === 'object') {
        if (val.answer) return val.answer;
        return val.bxAnswer.join(',')
      }
      return val;
    }
  },
  data() {
    let data = [
      '002300700',
      '604090802',
      '000060040',
      '000000623',
      '000203000',
      '700040000',
      '050920400',
      '000057200',
      '000600009'
    ]
    return {
      cs: {},
      bak: [],
      total: 0,
      cache: {}, i: 0, j: 0,
      originData: data.map(r => {
        return r.split('')
      }),
      data: []
    }
  },
  created() {
    this.data = this.copy();
    this.jieti();
  },
  methods: {
    copy() {
      let data = [];
      for (let i = 0; i < 9; i++) {
        if (!data[i]) data[i] = [];
        for (let j = 0; j < 9; j++) {
          if (!data[i][j]) data[i][j] = this.originData[i][j];
        }
      }
      return data;
    },
    jieti() {
      const [i, j] = this.findZero();
      if (i === undefined && j === undefined) {
        Log('第一轮结束')
        if (this.checkJiesu() === false) {
          this.cache = {};
          const [ii, jj] = this.findZxBx();
          const bx = this.getBxVal(ii, jj);
          const a = bx.shift();
          this.cs = {
            idx: [ii, jj],
            bx,
            a
          }
          this.originData[ii][jj] = a;
          this.data = this.copy();
          this.cache = {};
          Log('答题未结束，开始尝试', [ii, jj], a)
          this.jieti();
        }
        return;
      }
      this.i = i;
      this.j = j;
      const arr1 = this.getRow(i);
      const arr2 = this.getCol(j);
      const arr3 = this.getJgg(i, j);
      const arr = this.hbArr(arr1, arr2, arr3);

      if (arr.length === 0) {
        let {idx, bx, a} = this.cs;
        Log(idx, a, '尝试失败', bx);
        a = bx.shift();
        this.cs = {a, idx, bx};
        const [ii, jj] = idx;
        this.originData[ii][jj] = a;
        this.data = this.copy();
        Log('继续尝试', idx, a);
        this.cache = {};
        this.jieti();
        return;
      } else if (arr.length === 1) {
        this.cache = {};
        this.$set(this.data[i], j, arr[0]);
      } else {
        this.$set(this.data[i], j, {
          bxAnswer: arr
        });
      }

      setTimeout(() => {
        this.jieti();
      }, 100)
    },

    findZxBx() {
      for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
          const val = this.data[i][j];
          if (typeof val === 'object') {
            if (val.bxAnswer.length === 2) return [i, j];
          }
        }
      }
    },

    bakData() {
      const bak = new Array(9).fill(0).map(r => {
        return new Array(9).fill(0);
      })
      for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
          bak[i][j] = this.getVal(i, j);
        }
      }
      this.bak = bak;
    },

    addMark() {
      for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
          const item = this.data[i][j];
          if (typeof item === 'object') {
            this.setVal(i, j, {
              ...item,
              test: true
            })
          }
        }
      }
    },

    setVal(ii, jj, val) {
      this.$set(this.data[ii], jj, val);
    },

    jsTotal() {
      let total = 0;
      for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
          const val = this.getVal(i, j);
          if (val) total++;
        }
      }
      return total;
    },

    checkJiesu() {
      for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
          const val = this.getVal(i, j);
          if (!val) return false;
        }
      }
      return true;
    },
    getVal(i, j) {
      const val = this.data[i][j];
      if (typeof val !== 'object') return parseInt(val);
      else {
        if (val.answer) return parseInt(val.answer);
      }
      return 0;
    },
    getBxVal(i, j) {
      const val = this.data[i][j];
      return val.bxAnswer;
    },
    hbArr(arr1, arr2, arr3) {
      let tmp = [];
      for (let i = 0; i < arr1.length; i++) {
        let val = arr1[i];
        if (arr2.includes(val) && arr3.includes(val)) {
          tmp.push(val);
        }
      }
      return tmp;
    },
    getRow(i) {
      let tmp = new Array(9).fill('0').map((r, i) => i + 1);
      for (let j = 0; j < this.data[i].length; j++) {
        const val = this.getVal(i, j);
        if (val > 0) {
          let index = tmp.indexOf(val);
          if (index >= 0) tmp.splice(index, 1);
        }
      }
      return tmp;
    },
    getCol(j) {
      let tmp = new Array(9).fill('0').map((r, i) => i + 1);
      for (let i = 0; i < 9; i++) {
        const val = this.getVal(i, j);
        if (val > 0) {
          let index = tmp.indexOf(val);
          if (index >= 0) tmp.splice(index, 1);
        }
      }
      return tmp;
    },
    getJgg(i, j) {
      let is = parseInt(i / 3) * 3,
          ie = is + 2,
          js = parseInt(j / 3) * 3,
          je = js + 2;
      let tmp = new Array(9).fill('0').map((r, i) => i + 1);
      for (let k = is; k <= ie; k++) {
        for (let l = js; l <= je; l++) {
          const val = this.getVal(k, l);
          if (val > 0) {
            let index = tmp.indexOf(val);
            if (index >= 0) tmp.splice(index, 1);
          }
        }
      }
      return tmp;
    },
    findZero() {
      for (let i = 0; i < 9; i++) {
        for (let j = 0; j < 9; j++) {
          const key = `${i}${j}`;
          if (this.cache[key]) continue;
          this.cache[key] = true;
          const val = this.getVal(i, j);
          if (!val) return [i, j];
        }
      }
      return [undefined, undefined];
    }
  },
}
</script>

<style scoped>

</style>